// ─────────────────────────────────────────────────────────────────────────────
// Configuration d'environnement — SEUL endroit qui lit process.env.
//
// CRA injecte les variables REACT_APP_* au moment du build : elles doivent être
// référencées littéralement (process.env.REACT_APP_X) pour être remplacées.
// ─────────────────────────────────────────────────────────────────────────────

const trimTrailingSlash = (url: string): string => url.trim().replace(/\/+$/, "");

function required(name: string, value: string | undefined): string {
  if (!value || !value.trim()) {
    throw new Error(
      `[config] Variable ${name} manquante. Définissez-la dans .env (voir .env.example).`,
    );
  }
  return trimTrailingSlash(value);
}

const optional = (value: string | undefined): string | null =>
  value && value.trim() ? trimTrailingSlash(value) : null;

const backendApiUrl = required("REACT_APP_API_URL", process.env.REACT_APP_API_URL);

export const env = {
  /** Backend BI (.NET), préfixe /api inclus — ex: https://host/api */
  backendApiUrl,
  /**
   * Service IA / prévision (Flask, routes /prevision-f/*), préfixe /api inclus.
   * Si absent : même URL que le backend (service derrière le même gateway).
   */
  aiApiUrl: optional(process.env.REACT_APP_AI_API) ?? backendApiUrl,
} as const;
